import React, { Component } from "react";
import connnectionAlertLogo from '../../assets/alertDisconnectLarge.png';
import Flexbox from 'flexbox-react';
import {observer} from 'mobx-react';

const shopListPanel = {
    "width": "100%",
	"height": "100%"
};

const mainAlertMsgStyle = {
    "margin": "auto",
    "fontSize" : "4em",
    "fontFamily": "GraphikSemibold"
};

const subAlertMsgStyle = {
    "margin": "auto",
    "fontSize" : "3.2em",
    "fontFamily": "GraphikRegular"
};

@observer
export default class HallPanelConnectionAlert extends Component {
    render() {
        let alertBoxHeight = this.props.alertBoxHeight || "50%";

        return (
          <div style={shopListPanel}>
              <Flexbox flexDirection="column" height="100%" width="100%">
                   <Flexbox height="30%" width="100%">
                   </Flexbox>
                   <Flexbox height={alertBoxHeight} width="100%" flexDirection="row">
                       <Flexbox height="100%" width="25%"></Flexbox>
                       <Flexbox height="100%" width="50%" flexDirection="column">

                           <Flexbox width="100%" flexGrow={.4}></Flexbox>
                           <Flexbox height="35%" width="100%" >
                               <Flexbox height="100%" width="30%"></Flexbox>
                               <Flexbox height="100%" width="40%" >
                                   <div width="100%" height="100%">
                                       <img src={connnectionAlertLogo} alt=""  width="100%"/>
                                   </div>

                               </Flexbox>
                               <Flexbox height="100%" width="30%"></Flexbox>
                           </Flexbox>
                           <Flexbox width="100%" flexGrow={.6}></Flexbox>
                           <Flexbox height="25%" flexDirection="column">
                               <Flexbox height="10%" width="100%"></Flexbox>
                               <Flexbox  height="40%" width="100%">
                                   <div style={mainAlertMsgStyle}>
                                       CONNECTION LOST
                                   </div>
                               </Flexbox>
                               <Flexbox height="3%" width="100%"></Flexbox>
                               <Flexbox height="40%" width="100%">
                                   <div style={subAlertMsgStyle}>
                                       We'll be back soon
                                   </div>
                               </Flexbox>
                           </Flexbox>
                           <Flexbox width="100%" flexGrow={.8}></Flexbox>

                       </Flexbox>
                       <Flexbox height="100%" width="20%"></Flexbox>
                   </Flexbox>
                   <Flexbox height="25%" width="100%" >
                   </Flexbox>
              </Flexbox>
          </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/alerts/hall_panel_connection_alert.jsx